// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2EditorModal-module__formContent--Lv5Xb {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 10px;
  row-gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2EditorModal.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,YAAA;AACF","sourcesContent":[".formContent {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  column-gap: 10px;\n  row-gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContent": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2EditorModal-module__formContent--Lv5Xb`
};
export default ___CSS_LOADER_EXPORT___;
